<footer class="flex-shrink-0 px-6 py-3 flex items-center justify-between"
        style="background: #2E3190; border-top: 1px solid rgba(255,255,255,0.1);">
  <span class="text-xs" style="color: rgba(255,255,255,0.5);">
    © 2025 <span style="color: #FAB818; font-weight: 600;">Afrilink SAS</span> – Tous droits réservés
  </span>
  <span class="text-xs" style="color: rgba(255,255,255,0.35);">v2.0</span>
</footer>
